import { FC } from 'react';
import styles from './styles.module.scss';
import Typography from '@components/common/typography';
import { useTranslation } from 'react-i18next';
import { IModalComponentProps } from '@context/modal_context';
import { TCard } from '@xeppt/xeppt-sdk/types';
import { prettifyAmount } from '@utils/index';

const CardLimitsModal: FC<IModalComponentProps<TCard>> = ({ modalData }) => {
    const { t } = useTranslation('modals', {
        keyPrefix: 'card_limits'
    });

    return (
        <div className={styles.wrapper}>
            <Typography variant="h4">{t('title')}</Typography>
            <div className={styles.content}>
                <div className={styles.limit_item}>
                    <div className={styles.row}>
                        <Typography variant="body3" weight="semibold">
                            Usage limit
                        </Typography>
                        <Typography variant="body3" weight="semibold">
                            {prettifyAmount(modalData?.usage_limit.toFixed(2))} CAD
                        </Typography>
                    </div>
                    <div className={styles.progress_wrapper}>
                        <div
                            className={styles.progress}
                            style={{
                                width: modalData
                                    ? `${
                                          ((modalData.usage_limit - modalData.available_limit) /
                                              modalData.usage_limit) *
                                          100
                                      }%`
                                    : '0%'
                            }}
                        />
                    </div>
                    <div className={styles.row}>
                        <Typography variant="body4" weight="semibold">
                            <span>Used</span> <br />{' '}
                            {prettifyAmount(
                                (modalData.usage_limit - modalData.available_limit).toFixed(2)
                            )}{' '}
                            CAD{' '}
                        </Typography>
                        <Typography variant="body4" weight="semibold">
                            <span>Available</span> <br />{' '}
                            {prettifyAmount(modalData?.available_limit.toFixed(2))} CAD
                        </Typography>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CardLimitsModal;
